import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

const inputCls = "w-full bg-[#09090b] border border-[#27272a] focus:border-[#c8aa6e] outline-none px-3 py-2.5 text-sm text-[#fafafa] placeholder:text-[#52525b]";

export default function ChangePasswordDialog({ open, onOpenChange }) {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);

  const reset = () => { setCurrent(""); setNext(""); setConfirm(""); };

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 6) { toast.error("A nova palavra-passe deve ter pelo menos 6 caracteres"); return; }
    if (next !== confirm) { toast.error("As palavras-passe não coincidem"); return; }
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Palavra-passe alterada com sucesso");
      reset();
      onOpenChange(false);
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Erro ao alterar a palavra-passe");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) reset(); onOpenChange(v); }}>
      <DialogContent className="bg-[#18181b] border-[#27272a] text-[#fafafa] max-w-md" data-testid="change-password-dialog">
        <DialogHeader>
          <DialogTitle className="font-head text-lg flex items-center gap-2">
            <KeyRound className="w-4 h-4 text-[#c8aa6e]" /> Alterar palavra-passe
          </DialogTitle>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4 mt-2">
          <div>
            <label className="label-tiny block mb-1.5">Palavra-passe atual</label>
            <input data-testid="cp-current" type="password" value={current} onChange={(e) => setCurrent(e.target.value)} className={inputCls} required autoComplete="current-password" />
          </div>
          <div>
            <label className="label-tiny block mb-1.5">Nova palavra-passe</label>
            <input data-testid="cp-new" type="password" value={next} onChange={(e) => setNext(e.target.value)} className={inputCls} required minLength={6} autoComplete="new-password" />
          </div>
          <div>
            <label className="label-tiny block mb-1.5">Confirmar nova palavra-passe</label>
            <input data-testid="cp-confirm" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className={inputCls} required autoComplete="new-password" />
          </div>
          <button type="submit" disabled={saving} data-testid="cp-submit"
            className="w-full bg-[#c8aa6e] text-black hover:bg-[#d4b982] py-2.5 font-medium text-sm disabled:opacity-60 transition-colors">
            {saving ? "A guardar…" : "Guardar nova palavra-passe"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
